export const Step = {
  Pillow: 'Pillow',
  ExitToApplicant: 'ExitToApplicant',
  ExitToDashboard: 'ExitToDashboard',
};
